module.exports = __webpack_public_path__ + "uarm-images/tinymce-k11.gif";